import { render, staticRenderFns } from "./RegistrationImageComponent.vue?vue&type=template&id=31f9c374&lang=pug&"
import script from "./RegistrationImageComponent.vue?vue&type=script&lang=ts&"
export * from "./RegistrationImageComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports